// beauty ディレクトリ直下の js を全部取得
const modules = require.context('./', false, /\.js$/)

const ids = {}

modules.keys().forEach((key) => {
  if (key === './index.js') return

  const name = key.replace('./', '').replace('.js', '')
  ids[name] = modules(key).default
})

export default {
  ids,
  // トップページコンポーネント名（TopCommon.vue で使用）
  topComponent: 'Top4BeautyOEM',
  // 利用規約ルート名（/terms リダイレクト先）
  termsRouteName: 'beautytermsPage',
  // 許可するテンプレートIDのリスト（このリストにないテンプレートは非表示・アクセス不可）
  allowedFormats: ['rirekisho_beauty', 'entrysheet', 'letter'],
  // OEM専用テンプレート（通常サイトでは非表示）
  oemOnlyFormats: ['rirekisho_beauty'],
  defaultFormatId: 'rirekisho_beauty',
  // RT機能の有効/無効（false: 無効、true: 有効）
  enableRT: false,
  newsItems: [
    // {
    //   title: 'サロンツアーとか',
    //   description: '説明テキスト説明テキスト説明テキスト説明テキスト説明テキスト説明テキスト',
    //   image: 'https://placehold.jp/720x480.png',
    //   link: '#',
    //   isLoginOnly: true
    // },
    // {
    //   title: 'イベントとか',
    //   description: '説明テキスト説明テキスト説明テキスト説明テキスト説明テキスト説明テキスト',
    //   image: 'https://placehold.jp/720x480.png',
    //   link: '#',
    //   isLoginOnly: true
    // }
  ],
  shopItems: [
    // 最大3つまで
    // {
    //   image: '/static/img/beauty/top/shopimg01.webp',
    //   link: '',
    //   alt: 'INFINIAL'
    // },
    // {
    //   image: '/static/img/beauty/top/shopimg02.webp',
    //   link: '',
    //   alt: 'HIKARI'
    // },
    // {
    //   image: '/static/img/beauty/top/shopimg03.webp',
    //   link: '',
    //   alt: 'jOeWELL®'
    // }
  ]
}
